// @flow

import $ from 'jquery'

import Translation from '../i18n/Translation'

export default class FinishDialog {

  static init () {
    let showButton = false

    let mode = "order"
    let showFinishDialog = localStorage.getItem('vol_dm_finish_status')
    if (showFinishDialog) {
      mode = "dm"
    } else {
      showFinishDialog = localStorage.getItem('vol_orders_finish_status')
      showButton = true
      mode = "order"
    }

    //DEBUG
    //showFinishDialog = "success"
    //showButton = true

    if (showFinishDialog) {
      $('#finish-dialog').removeClass('hidden')
     
      //Conversion-Tracking
      if (mode = "order") {
        if (gtag) {
          gtag('event', 'vertragsabschluss',
            { 'event_category': 'Formular', 
              'event_label': 'Vertrag abgeschlossen'
            }
          )
        }
      }

      if (showButton == true) {
        let $btn = $('#finish-dialog .to-dm-btn') 
        $btn.removeClass('hidden')
        $btn.click(()=> {
          localStorage.setItem('vol_order_completed', 'true')
          localStorage.removeItem('vol_orders_finish_status')

          setTimeout ( ()=> {
            window.location = "/direktvermarktung"
          }, 300)

        })
      }
      $(document.body).addClass('fade')

      const success = showFinishDialog === 'success' ? 'success' : 'failed'

      $('#finish-dialog .dialog-title').html(Translation.getText(`order_dialog_message_${success}`))
      $('#finish-dialog .dialog-description').html(Translation.getText(`order_dialog_description_${success}`))
      $('#finish-dialog .dialog-icon').addClass('hidden')
      $(`#finish-dialog #icon-${success}`).removeClass('hidden')

      $('#close-finish-dialog').click(() => {
        Object.keys(localStorage)
          .filter(key => key.includes('vol_orders'))
          .forEach(key => {
            showFinishDialog
              ? localStorage.removeItem(key)
              : localStorage.removeItem('vol_orders_finish_status')
          })
        Object.keys(localStorage)
          .filter(key => key.includes('vol_dm'))
          .forEach(key => {
            showFinishDialog
              ? localStorage.removeItem(key)
              : localStorage.removeItem('vol_dm_finish_status')
          })


        $('#finish-dialog').addClass('hidden')
        $(document.body).removeClass('fade')
      })
    }
  }
}
